import styled from 'styled-components';

export const MainContainer = styled.div`
  padding: 20px;
  width: 85vw;
  overflow-x: auto;
`;

export const NewHeader = styled.div`
  background-color: white;
  padding: 10px;
  width: 100%;
  border-radius: 7px;
  display:flex;
  justify-content : space-between;
  font-size: large;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const TopDiv = styled.div`
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
`;

export const SelectorContainer = styled.div`
  display: flex;
`;

export const Selector = styled.div`
  display: flex;
  flex-direction: column; 
`;
